import React, { useEffect, useState } from "react";

// GovMap & jQuery globals
declare const govmap: any;
declare const $: any;

interface MapComponentProps {
    id?: string;
    layerNumber?: string;
    activeLayerNumber?: string;
}

const MapComponent = ({
    id = 'map',
    layerNumber,
    activeLayerNumber
}: MapComponentProps) => {
    const [loadedMaps, setLoadedMaps] = useState<string[]>([]);
    const [mapInstance, setMapInstance] = useState<any>(null);

    const finalActiveLayerNumber =
        activeLayerNumber && activeLayerNumber !== 'undefined' && activeLayerNumber !== 'null'
            ? String(activeLayerNumber)
            : '00000';

    // Load scripts and initialize map
    useEffect(() => {
        const loadScriptsAndMap = () => {
            if (loadedMaps.includes(id)) return;

            const jqueryScript = document.createElement("script");
            jqueryScript.src = "https://code.jquery.com/jquery-1.12.1.min.js";
            jqueryScript.async = true;
            document.body.appendChild(jqueryScript);

            jqueryScript.onload = () => {
                const apiUrl = 'https://www.govmap.gov.il/govmap/api/govmap.api.js';
                const token = 'fe827829-8b7a-4ef6-85ed-3ae1caebaf64';

                if (!apiUrl || !token) {
                    console.error("Missing API URL or Token");
                    return;
                }

                const govmapScript = document.createElement("script");
                govmapScript.src = apiUrl;
                govmapScript.async = true;
                document.body.appendChild(govmapScript);

                govmapScript.onload = () => {
                    $(document).ready(() => {
                        if (!document.getElementById(id)) return;

                        setLoadedMaps(prev => [...prev, id]);

                        const map = govmap.createMap(id, {
                            token,
                            layers: [finalActiveLayerNumber],
                            visibleLayers: [finalActiveLayerNumber],
                            showXY: true,
                            identifyOnClick: true,
                            isEmbeddedToggle: false,
                            background: "0",
                            layersMode: 2,
                            zoomButtons: false,
                            onLoad: () => {
                                setMapInstance(map);
                                console.log("Map loaded.");

                                setTimeout(() => {
                                    trySendingFilter(map, 5);
                                }, 500);
                            }
                        });
                    });
                };
            };
        };

        // Safe filter function with retries
        const trySendingFilter = (map: any, retries: number) => {
            console.log('GovMap Filter Layers: ', govmap?.filterLayers)
            console.log('Map Instance: ', map)
            if (!map || !govmap?.filterLayers) {
                if (retries > 0) {
                    console.warn("GovMap API not ready, retrying...");
                    setTimeout(() => trySendingFilter(map, retries - 1), 500);
                } else {
                    console.error("GovMap API failed to become ready.");
                }
                return;
            }

            const params = {
                layerName: finalActiveLayerNumber,
                whereClause: `internalid LIKE '${layerNumber || 22}%'`,
                // whereClause: "objectid IS NOT NUll",
                zoomToExtent: true
            };

            try {
                console.log("Sending filterLayers with params:", params);
                govmap.filterLayers(params);
            } catch (error: any) {
                const msg = error?.message || "";
                console.warn("GovMap threw an error:", msg);
                if (retries > 0 && msg.includes("No active message ports")) {
                    setTimeout(() => trySendingFilter(map, retries - 1), 500);
                } else {
                    console.error("filterLayers failed permanently.");
                }
            }
            // setTimeout(() => trySendingFilter(map, retries - 1), 500);
        };
        loadScriptsAndMap();
    }, [id, layerNumber, activeLayerNumber]);

    // Filter again if layerNumber changes
    useEffect(() => {
        if (!mapInstance || !layerNumber || !govmap?.filterLayers) return;

        const params = {
            layerName: finalActiveLayerNumber,
            whereClause: `internalid LIKE '${layerNumber}%'`,
            // whereClause: "objectid IS NOT NUll",
            zoomToExtent: true
        };

        console.log("Updating filter on mapInstance change:", params);
        govmap.filterLayers(params);
    }, [layerNumber, mapInstance]);

    return (
        <div
            id={id}
            style={{ width: "100%", height: "100%", borderRadius: "12px" }}
        />
    );
};

export default MapComponent;

//
// import React, {useEffect, useState} from "react";
// import LoaderComponent from "../LoaderComponent/LoaderComponent";
//
// // Suppress TS error since govmap is injected by script
// declare const govmap: any;
// declare const $: any;
//
// interface MapComponentProps {
//     id?: string;
//     layerNumber?: string;
//     activeLayerNumber?: string;
// }
//
// const MapComponent = ({
//     id = 'map',
//     layerNumber,
//     activeLayerNumber
// }: MapComponentProps) => {
//     const [loadedMaps, setLoadedMaps] = useState<any>([]);
//
//     useEffect(() => {
//         const loadScripts = async () => {
//             // Load jQuery
//             const jqueryScript = document.createElement("script");
//             jqueryScript.src = "https://code.jquery.com/jquery-1.12.1.min.js";
//             jqueryScript.async = true;
//             document.body.appendChild(jqueryScript);
//
//             // Wait for jQuery to load
//             jqueryScript.onload = () => {
//                 // Load GovMap API
//                 const apiUrl = process.env.REACT_APP_API_URL;
//                 if (!apiUrl) {
//                     console.error('REACT_APP_API_URL environment variable is not defined');
//                     return;
//                 }
//
//                 const govmapScript = document.createElement("script");
//                 govmapScript.src = apiUrl;
//                 govmapScript.async = true;
//                 document.body.appendChild(govmapScript);
//
//                 govmapScript.onload = () => {
//                     $(document).ready(function () {
//                         if(document.getElementById(id) && loadedMaps.indexOf(id) === -1) {
//                             setLoadedMaps(loadedMaps.push(id));
//                             govmap.createMap(id,
//                                 {
//                                     token: process.env.REACT_APP_GOVMAP_TOKEN,
//                                     layers: ["216600"],
//                                     visibleLayers: ["216600"],
//                                     showXY: true,
//                                     identifyOnClick: true,
//                                     isEmbeddedToggle: false,
//                                     background: "0",
//                                     layersMode: 2,
//                                     zoomButtons: false,
//                                     onLoad: function(e: any) {
//                                         setTimeout(() => {
//                                             const params = {layerName: "216600", whereClause: "objectid IS NOT NUll", zoomToExtent: true};
//                                             govmap.filterLayers(params);
//                                         }, 500)
//                                     }
//                                 });
//                         }
//                     });
//                 };
//             };
//         };
//
//         loadScripts();
//     }, []);
//
//     return (
//         <div
//             id={id}
//             style={{width: "100%", height: "100%", borderRadius: "12px"}}
//         />
//     );
// };
//
// export default MapComponent;
